var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgData = function SvgData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd",
    transform: "translate(-148.000000, -80.000000)",
    opacity: 0.900000036
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(148.000000, 80.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38886057,12.9049048 L5.76336956,16.055494 C5.91435641,16.3367926 6,16.6583948 6,17 C6,18.1045695 5.1045695,19 4,19 C2.8954305,19 2,18.1045695 2,17 C2,15.8954305 2.8954305,15 4,15 C4.21314434,15 4.41850122,15.0333421 4.61113943,15.0950952 L7.23663044,11.944506 C7.08564359,11.6632074 7,11.3416052 7,11 C7,9.8954305 7.8954305,9 9,9 C10.1045695,9 11,9.8954305 11,11 C11,11.1991082 10.9709046,11.3914209 10.9167335,11.5729182 L13.0204527,13.2558935 C13.3099577,13.0929486 13.6441242,13 14,13 C14.1772467,13 14.3491081,13.023057 14.5127486,13.0663352 L18.2873783,8.0334956 C18.1049755,7.73188085 18,7.37819959 18,7 C18,5.8954305 18.8954305,5 20,5 C21.1045695,5 22,5.8954305 22,7 C22,8.1045695 21.1045695,9 20,9 C19.8227533,9 19.6508919,8.97694304 19.4872514,8.93366484 L15.7126217,13.9665044 C15.8950245,14.2681192 16,14.6218004 16,15 C16,16.1045695 15.1045695,17 14,17 C12.8954305,17 12,16.1045695 12,15 C12,14.8008918 12.0290954,14.6085791 12.0832665,14.4270818 L9.97954732,12.7441065 C9.69004234,12.9070514 9.35587582,13 9,13 C8.78685566,13 8.58149878,12.9666579 8.38886057,12.9049048 Z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data.d7881ec7.svg";
export { ForwardRef as ReactComponent };